class ProductSwatches extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.addEventListener('change', this.onChange.bind(this));
    });

    this.variants = JSON.parse(this.querySelector('[type="application/json"]').textContent);

    if (!this.variants) {
      console.error('No variants found');
      return;
    }

    this.productCard = this.closest('[data-product-card]');
    this.productCardImageContainer = this.productCard.querySelector('[data-product-card-image]');
    this.productCardImage = this.productCardImageContainer.querySelectorAll('img')[0];
    this.productCardLinks = this.productCard.querySelectorAll('a');
    this.productCardForm = this.productCard.querySelector('form');
    this.productCardPrice = this.productCard.querySelector('.price');
  }

  onChange(event) {
    const input = event.target;
    const value = input.value;
    const variant = this.variants.find(variant => variant.option1 === value);

    // update the image
    if (this.productCardImage) {
      this.productCardImage.src = variant.featured_image;
      this.productCardImage.srcset = '';
    }

    // update the price
    if (this.productCardPrice) {
      this.productCardPrice.textContent = variant.variant_price;
    }

    // update the url
    this.productCardLinks.forEach((link) => {
      link.href = variant.url;
      link.title = variant.title;
    });

    //check for availability
    if (variant.available) {
      this.productCard.classList.remove(...['opacity-50', 'saturate-50']);
    }
    else {
      this.productCard.classList.add(...['opacity-50', 'saturate-50']);
    }

    if (this.productCardForm) {
      this.productCardForm.querySelector('input[name="id"]').value = variant.variant_id;
    }

    window.dispatchEvent(
      new CustomEvent('product:swatch-change', {
        bubbles: true,
        detail: {
          variantId: variant.variant_id,
          productCardForm: this.productCard.querySelector('product-form-component') || null,
        },
      }),
    );
  }
}
if (!customElements.get('product-swatches')) {
  customElements.define('product-swatches', ProductSwatches);
}
